module.exports = __webpack_public_path__ + "components/home-header/static/header-6--large-6cfaeabff9d1be186a2e25ceee8b9162.jpg";